// 19.1.3.1 Object.assign(target, source)
var $export = require('./_export');

$export($export.S + $export.F, 'Object', { assign: require('./_object-assign') });



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.5.6@core-js/library/modules/es6.object.assign.js
// module id = 255
// module chunks = 0 1